import axios from '../../../api/axios.js'

// 公司转账账户详情
export const findAcconutDetails = (params) => {
    return axios.get('merchant/api/receipt-settings/app', { params })
}
// 线下支付短信通知
export const getPaymentInform = (params) => {
    return axios.post('payment/api/app/payments/send/message', params)
}
// 开户信息
export const getOpenInfo = (params) => {
    return axios.get('payment/api/accounts/open-info', { params })
}
// 预充钱包
export const getActivityWallet = (params) => {
    return axios.get('payment/app/activity-wallet/wallet-info', { params })
}
// 活动钱包账单
export const getActivityBill = (params) => {
    return axios.get('payment/app/activity-wallet/bill-info', { params })
}
// 查看绑卡记录
export const getBankCard = (params) => {
    return axios.get('payment/api/bankcard/bind-record', { params })
}
// 个人/企业认证
export const postAuth = (params) => {
    return axios.post('payment/api/accounts/auth', params)
}
// 查看认证信息
export const checkAuthInfo = (params) => {
    return axios.get(`payment/api/accounts/auth-info/${params.companyCode}`, { params })
}
// 个人/企业开户信息
export const postOpen = (params) => {
    return axios.post(`payment/api/accounts/app/open-account`, params)
}
// 活动钱包发起赎回
export const postRansom = (params) => {
    return axios.post(`/payment/app/activity-wallet/ransom`, params)
}
// 活动钱包申请结果列表
export const getRansomResult = (params) => {
    return axios.get(`/payment/app/activity-wallet/ransom-result`, { params })
}
// 个人升级判断
export const isUpgrade = (params) => {
    return axios.get(`/payment/api/accounts/individual-upgrade`, { params })
}
// 设置支付密码
export const setPayPass = (params) => {
    return axios.post(`/payment/api/app/payments/password`, params)
}
// 修改支付密码
export const editPayPass = (params) => {
    return axios.put(`/payment/api/app/payments/password`, params)
}
// 重置支付密码-短信验证码
export const paySendSms = (params) => {
    return axios.post(`/payment/api/app/payments/reset-password/send-sms?phoneNumber=${params.phoneNumber}`, params)
}
// 重置支付密码
export const resetPayPass = (params) => {
    return axios.put(`/payment/api/app/payments/reset-password`, params)
}
// 是否设置支付密码
export const isPayPass = (params) => {
    return axios.get(`/payment/api/app/payments/exist-password`, { params })
}
